module.exports = __webpack_public_path__ + "images/canonical-card/duedate-complete-icon.ae9932d5b43424dc9f91.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/canonical-card/duedate-complete-icon.svg
// module id = 2YSq
// module chunks = 0